import { selectCurrentUserEmailIntegration } from '../../../store/emailHub/emailUsers'
import { useAppSelector } from '../../../store/hooks'

import { PluginPromo, PromoType } from '../../../components/Promo/Plugin/PluginPromo'
import { IntegrationIcon } from '../../../components/IntegrationIcon'

import { IntegrationServiceId } from '../../../common/integrations'

export const EmailPluginPromo = () => {
  const emailIntegration = useAppSelector(selectCurrentUserEmailIntegration)

  if (!emailIntegration || emailIntegration.serviceId !== 'outlookMail') {
    return null
  }

  return (
    <PluginPromo
      Icon={<IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_MAIL} width={32} height={32} />}
      InstallButton={
        <a
          className='button-link-medium outlook-promo-button text-decoration-none p-2 zocks-border-0.25'
          href='https://appsource.microsoft.com/en-us/product/office/WA200008950'
          target='_blank'
          rel='noreferrer noopeener'
        >
          Install Outlook Add-in
        </a>
      }
      header='Bring Zocks to your Outlook'
      body='Access AI responses, client insights, and task tracking directly in your inbox. No switching between apps needed.'
      containerClassname='outlook-promo-container'
      promoType={PromoType.OUTLOOK_MAIL}
    />
  )
}
